import React from 'react';

const AedPrice = ({ amount, size, iconSize, style, className, decimals = 2 }) => {
  const formatted = typeof amount === 'number'
    ? amount.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
    : amount;

  // If size is explicitly provided, use fixed px values; otherwise use em units to inherit from parent
  const useEm = !size;
  const iSize = useEm ? '0.9em' : `${iconSize || Math.round(size * 0.85)}px`;
  const gap = useEm ? '0.2em' : `${Math.round(size * 0.25)}px`;

  return (
    <span className={className} style={{ display: 'inline-flex', alignItems: 'center', gap, direction: 'ltr', ...style }}>
      <span
        aria-label="AED"
        role="img"
        style={{
          display: 'inline-block',
          width: iSize,
          height: iSize,
          flexShrink: 0,
          backgroundColor: 'currentColor',
          WebkitMaskImage: 'url(/uploads/icons/aed.svg)',
          WebkitMaskSize: 'contain',
          WebkitMaskRepeat: 'no-repeat',
          WebkitMaskPosition: 'center',
          maskImage: 'url(/uploads/icons/aed.svg)',
          maskSize: 'contain',
          maskRepeat: 'no-repeat',
          maskPosition: 'center'
        }}
      />
      <span>{formatted}</span>
    </span>
  );
};

export default AedPrice;
